"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("./util");

var BISTATE = Symbol('BISTATE');

exports.isBistate = function (input) {
  return !!(input && input[BISTATE]);
};

var getBistateValue = function getBistateValue(value, currentProxy, previousProxy) {
  var status = '';
  /**
   * if previousProxy exists, it is in reusing phase
   * otherwise is in initializing phase
   */

  if (previousProxy) {
    if (exports.isBistate(value)) {
      var parent_1 = value[BISTATE].getParent(); // reuse bistate

      if (parent_1 === previousProxy) {
        status = 'reuse';
      } else {
        status = 'create';
      }
    } else if (util_1.isArray(value) || util_1.isObject(value)) {
      status = 'create';
    }
  } else if (util_1.isArray(value) || util_1.isObject(value)) {
    status = 'create';
  }

  if (status === 'reuse') {
    value = value[BISTATE].compute();
    value[BISTATE].setParent(currentProxy);
  } else if (status === 'create') {
    value = createBistate(value);
    value[BISTATE].setParent(currentProxy);
  }

  return value;
};

var fillObjectBistate = function fillObjectBistate(currentProxy, initialObject, target, scapegoat, previousProxy) {
  for (var key in initialObject) {
    var value = getBistateValue(initialObject[key], currentProxy, previousProxy);
    scapegoat[key] = value;
    target[key] = value;
  }
};

var fillArrayBistate = function fillArrayBistate(currentProxy, initialArray, target, scapegoat, previousProxy) {
  for (var i = 0; i < initialArray.length; i++) {
    var item = getBistateValue(initialArray[i], currentProxy, previousProxy);
    scapegoat[i] = item;
    target[i] = item;
  }
};

exports.isMutable = false;
var dirtyStateList = [];

var commit = function commit() {
  var list = dirtyStateList;
  dirtyStateList = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    item[BISTATE].trigger();
  }
};

exports.mutate = function (f) {
  if (!util_1.isFunction(f)) {
    throw new Error("Expected f in mutate(f) is a function, but got " + f + " ");
  }

  if (f[Symbol.toStringTag] === 'AsyncFunction') {
    throw new Error("mutate(f) don't support async function");
  }

  var previousFlag = exports.isMutable;
  exports.isMutable = true;

  try {
    var result = f();

    if (util_1.isThenable(result)) {
      throw new Error("mutate(f) don't support async function");
    }

    return result;
  } finally {
    exports.isMutable = previousFlag;
    if (!previousFlag) commit();
  }
};

var createBistate = function createBistate(initialState, previousProxy) {
  if (previousProxy === void 0) {
    previousProxy = null;
  }

  if (!util_1.isArray(initialState) && !util_1.isObject(initialState)) {
    throw new Error("Expected initialState to be array or object, but got " + initialState);
  }

  var scapegoat = util_1.isArray(initialState) ? [] : {};
  var target = util_1.isArray(initialState) ? [] : {};
  var consuming = false;
  var watcher = null;

  var watch = function watch(f) {
    if (watcher) throw new Error("bistate can not be watched twice");
    if (!scapegoat) throw new Error("current state is immutable, can not be watched now");
    if (parent) throw new Error("Only root node can be watched");
    watcher = f;

    if (isDirty) {
      trigger();
    } else {
      consuming = true;
    }

    return unwatch;
  };

  var unwatch = function unwatch() {
    consuming = false;
    watcher = null;
  };

  var parent = null;

  var setParent = function setParent(input) {
    parent = input;
  };

  var getParent = function getParent() {
    return parent;
  };

  var deleteParent = function deleteParent() {
    parent = null;
  };

  var isDebug = false;

  var debug = function debug() {
    isDebug = true;
  };

  var undebug = function undebug() {
    isDebug = false;
  };

  var isDirty = false;

  var notify = function notify() {
    isDirty = true;

    if (!dirtyStateList.includes(currentProxy)) {
      dirtyStateList.push(currentProxy);
    }

    if (parent) {
      parent[BISTATE].notify();
    }
  };

  var isLock = false;
  var onLock = null;

  var lock = function lock(f) {
    isLock = true;
    onLock = f;
  };

  var unlock = function unlock() {
    isLock = false;
    onLock = null;
    if (isDirty) trigger();
  };

  var trigger = function trigger() {
    if (!watcher || isLock) {
      if (isLock && util_1.isFunction(onLock)) {
        onLock();
      }

      return;
    }

    var f = watcher;
    var nextProxy = compute();

    if (nextProxy !== currentProxy) {
      f(nextProxy);
    }
  };

  var compute = function compute() {
    if (!isDirty) return currentProxy;
    isDirty = false;
    /**
     * redo
     * create nextProxy based on scapegoat and target
     * reuse unchanged value as possible
     */

    var nextProxy = createBistate(scapegoat, currentProxy);
    /**
     * undo
     * clear scapegoat to keep currentProxy as immutable
     */

    scapegoat = null;
    onLock = null;
    deleteParent();
    unwatch();
    return nextProxy;
  };

  var internal = {
    watch: watch,
    setParent: setParent,
    getParent: getParent,
    deleteParent: deleteParent,
    notify: notify,
    compute: compute,
    trigger: trigger,
    lock: lock,
    unlock: unlock,
    debug: debug,
    undebug: undebug
  };
  var handlers = {
    get: function get(target, key) {
      if (key === BISTATE) return internal;

      if (exports.isMutable && scapegoat) {
        return Reflect.get(scapegoat, key);
      } else {
        return Reflect.get(target, key);
      }
    },
    set: function set(_, key, value) {
      if (exports.isMutable && scapegoat) {
        var result = Reflect.set(scapegoat, key, value);
        if (isDebug) debugger;
        notify();
        return result;
      } else {
        throw new Error("state is immutable, it's not allowed to set property: " + key);
      }
    },
    deleteProperty: function deleteProperty(_, key) {
      if (exports.isMutable && scapegoat) {
        var result = Reflect.deleteProperty(scapegoat, key);
        if (isDebug) debugger;
        notify();
        return result;
      } else {
        throw new Error("state is immutable, it's not allowed to delete property: " + key);
      }
    },
    has: function has(target, key) {
      if (exports.isMutable && scapegoat) {
        return Reflect.has(scapegoat, key);
      } else {
        return Reflect.has(target, key);
      }
    },
    ownKeys: function ownKeys(target) {
      if (exports.isMutable && scapegoat) {
        return Reflect.ownKeys(scapegoat);
      } else {
        return Reflect.ownKeys(target);
      }
    },
    getPrototypeOf: function getPrototypeOf(target) {
      if (exports.isMutable && scapegoat) {
        return Reflect.getPrototypeOf(scapegoat);
      } else {
        return Reflect.getPrototypeOf(target);
      }
    },
    setPrototypeOf: function setPrototypeOf() {
      throw new Error("bistate only supports plain object or array, it's not allowed to setPrototypeOf");
    },
    getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, prop) {
      if (exports.isMutable && scapegoat) {
        return Reflect.getOwnPropertyDescriptor(scapegoat, prop);
      } else {
        return Reflect.getOwnPropertyDescriptor(target, prop);
      }
    },
    defineProperty: function defineProperty(_, property) {
      throw new Error("bistate only supports plain object or array, it's not allowed to defineProperty: " + property);
    }
  };
  var currentProxy = new Proxy(target, handlers);

  if (util_1.isArray(currentProxy)) {
    fillArrayBistate(currentProxy, initialState, target, scapegoat, previousProxy);
  } else {
    fillObjectBistate(currentProxy, initialState, target, scapegoat, previousProxy);
  } // clear previousProxy


  previousProxy = null; // clear initialState

  initialState = null;
  return currentProxy;
};

function default_1(initialState) {
  return createBistate(initialState, null);
}

exports.default = default_1;

exports.watch = function (state, watcher) {
  if (!exports.isBistate(state)) {
    throw new Error("Expected state to be a bistate, but received " + state);
  }

  if (!util_1.isFunction(watcher)) {
    throw new Error("Expected watcher to be a function, but received " + watcher);
  }

  return state[BISTATE].watch(watcher);
};

exports.lock = function (state, f) {
  if (!exports.isBistate(state)) {
    throw new Error("Expected state to be a bistate, but received " + state);
  }

  state[BISTATE].lock(f);
};

exports.unlock = function (state) {
  if (!exports.isBistate(state)) {
    throw new Error("Expected state to be a bistate, but received " + state);
  }

  state[BISTATE].unlock();
};

exports.debug = function (state) {
  if (!exports.isBistate(state)) {
    throw new Error("Expected state to be a bistate, but received " + state);
  }

  state[BISTATE].debug();
};

exports.undebug = function (state) {
  if (!exports.isBistate(state)) {
    throw new Error("Expected state to be a bistate, but received " + state);
  }

  state[BISTATE].undebug();
};

exports.remove = function (state) {
  if (!exports.isBistate(state)) {
    throw new Error("Expected state to be a bistate, but received " + state);
  }

  var parent = state[BISTATE].getParent();
  if (!parent) return false;

  if (util_1.isArray(parent)) {
    var index = parent.indexOf(state);
    parent.splice(index, 1);
    return true;
  }

  if (util_1.isObject(parent)) {
    for (var key in parent) {
      var value = parent[key];

      if (value === state) {
        delete parent[key];
        return true;
      }
    }
  }

  return false;
};